import React, { useCallback, useEffect, useState } from 'react';

import { ClickAwayListener, Grow, Popper } from '@material-ui/core';
import styled from 'styled-components';
import { Button } from 'styles/admin';
import { StyledBox, StyledButton, StyledPaper } from 'styles/common';

import theme from 'constants/theme';

import DateRangePicker from 'uiToolkit/materialui-daterange-picker-copy/';
import 'uiToolkit/materialui-daterange-picker-copy/dateRangePicker.css';

/* this component should do the following things.
  - display a daterangepicker
  - display a defined range list
  - onSelection of these dates, it should close and returns selected dates.
  - on Selection of defined dateranges close the calendar and selected the dates.
*/

const MeshDateRangePicker = ({
  selectedDateRange,
  minDate,
  maxDate,
  definedRanges,
  onSelectDateRange,
  onClose,
  isOpen,
  anchorEl,
  popupPlacement = 'bottom-end',
  clearable = false,
  primaryActionText = 'Apply',
  secondaryActionText = 'Reset',
  modifiers,
  disablePortal = true,
  zIndex,
}) => {
  const [dateRange, setDateRange] = useState(selectedDateRange);

  const handleClickAway = useCallback(() => {
    setDateRange(selectedDateRange);
    onClose();
  }, [selectedDateRange]);

  const handleDateChange = useCallback((dateRange) => {
    const updatedEndDate = new Date(dateRange.endDate).setHours(23, 59, 59);
    const newDateObj = {
      ...dateRange,
      endDate: new Date(updatedEndDate),
    };
    setDateRange(newDateObj);
  }, []);

  const handleSubmit = () => {
    onSelectDateRange(dateRange);
  };

  const handleClear = () => {
    onSelectDateRange({});
  };

  useEffect(() => {
    setDateRange(selectedDateRange);
  }, [selectedDateRange]);

  return (
    <StyledPopper
      className="daterangepicker-popper"
      open={isOpen}
      anchorEl={anchorEl}
      placement={popupPlacement}
      disablePortal={disablePortal}
      modifiers={modifiers}
      zIndex={zIndex}
    >
      <Grow>
        <ClickAwayListener onClickAway={handleClickAway}>
          <StyledPaper>
            <DateRangePicker
              open
              minDate={minDate}
              maxDate={maxDate}
              initialDateRange={dateRange}
              onChange={handleDateChange}
              definedRanges={definedRanges}
            />
            <StyledBox
              display="flex"
              padding="0.5rem 1rem"
              justifyContent="flex-end"
              borderTop={`1px solid ${theme.palette.borders.lightGrey}`}
            >
              {clearable && (
                <StyledButton
                  size="large"
                  fontColor="primary"
                  rightGutter={3}
                  style={{
                    width: '10rem',
                    height: '2.5rem',
                    marginRight: '1rem',
                    borderColor: theme.palette.primary.main,
                  }}
                  onClick={handleClear}
                  variant="outlined"
                >
                  {secondaryActionText}
                </StyledButton>
              )}
              <Button
                size="large"
                blue
                rightGutter={3}
                style={{ width: '10rem', height: '2.5rem' }}
                onClick={handleSubmit}
              >
                {primaryActionText}
              </Button>
            </StyledBox>
          </StyledPaper>
        </ClickAwayListener>
      </Grow>
    </StyledPopper>
  );
};

const StyledPopper = styled(Popper)`
  z-index: ${({ zIndex }) => zIndex ?? '99'};
`;
export default MeshDateRangePicker;
